import React, { Dispatch } from 'react';
import { Button, Card, List, Tooltip } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { Action } from 'typesafe-actions';
import { loadRequest } from '../../../store/ducks/tracking/actions';
import { ApplicationState } from '../../../store';
import { RowLine, SpanBlock } from './styles';
import ModalNota from './ModalNota';
import GetStatus from '../../../components/GetStatus';
import moment from 'moment';
import { DownloadOutlined } from '@ant-design/icons';

const CardMobile: React.FC<any> = ({ filter, handleDownload }) => {
  const pagination = useSelector((state: ApplicationState) => state.Tracking.pagination);
  const loading = useSelector((state: ApplicationState) => state.Tracking.loading);
  const inscricaoAtiva = useSelector((state: ApplicationState) => state.auth.inscricaoAtiva);
  const cddAtivo = useSelector((state: ApplicationState) => state.auth.cddAtivo);
  const data = useSelector((state: ApplicationState) => state.Tracking.data);
  const dispatch = useDispatch<Dispatch<Action>>();

  const paginationProps = {
    onChange: (pag: any) => {
      const resultado = {
        ...pagination,
        current: pag,
      };
      dispatch(
        loadRequest(
          filter,
          filter?.codParceiro ? [+filter.codParceiro] : inscricaoAtiva,
          cddAtivo?.codCdd as number,
          resultado
        )
      );
    },
    showSizeChanger: true,
    current: pagination.current,
    pageSize: pagination.pageSize,
    total: pagination.total,
  };

  return (
    <List
      grid={{ gutter: 16, column: 1 }}
      pagination={paginationProps}
      loading={loading}
      dataSource={data}
      renderItem={(item) => (
        <List.Item>
          <Card
            title={
              <span style={{ textAlign: 'center' }}>
                <GetStatus acronym={item.status} />
              </span>
            }
          >
            <RowLine>
              <p>
                <strong>Nota</strong>
                <SpanBlock>
                  <ModalNota record={item} />
                </SpanBlock>
              </p>
              <p>
                <strong>Veículo</strong> <SpanBlock>{item.placa}</SpanBlock>
              </p>
            </RowLine>
            <RowLine>
              <p>
                <strong>Cliente</strong> <SpanBlock>{item.destinatario}</SpanBlock>
              </p>
            </RowLine>
            <RowLine>
              <p>
                <strong>Localização do veículo</strong>
                <SpanBlock>{item.localizacao}</SpanBlock>
              </p>
            </RowLine>

            <RowLine>
              <p>
                <strong>Cidade origem</strong> <SpanBlock>{item.cidadeOrigem}</SpanBlock>
              </p>
              <p>
                <strong>Cidade destino</strong> <SpanBlock>{item.cidadeDestino}</SpanBlock>
              </p>
            </RowLine>
            <RowLine>
              <p>
                <strong>Previsão de entrega</strong>{' '}
                <SpanBlock>{moment(item.dtPrevChegada).format('lll')}</SpanBlock>
              </p>
            </RowLine>
            <div style={{ width: '100%' }}>
              <Tooltip title={item?.qtdAnexo === 0 ? 'Não há canhoto' : ''}>
                <Button
                  icon={<DownloadOutlined />}
                  onClick={() => handleDownload(item)}
                  disabled={item?.qtdAnexo === 0 ? true : false}
                  type="primary"
                  style={{ width: '100%' }}
                >
                  Baixar canhoto
                </Button>
              </Tooltip>
            </div>
          </Card>
        </List.Item>
      )}
    />
  );
};
export default CardMobile;
